export default "__VITE_ASSET__BtIU3g6H__"